import {Action} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid} from '@dms/shared';

import {buildArray, composePath, noop, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function UserOverview() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('detail', () =>
        navigate(composePath(settingsRoutes.userManagementDetailV2, {params: {id}}))
      )
      .otherwise(noop);
  };

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('entity.user.labels.users'),
        actions: buildArray<Action>()
          .whenFeatureEnabled(featureFlags.USER_INVITATION, {
            type: 'button',
            title: i18n.t('page.settings.actions.inviteUser'),
            onClick: () => navigate(settingsRoutes.userManagementInviteUser),
            'data-testid': testIds.settings.userManagement('inviteUser'),
          })
          .add({
            type: 'button',
            title: i18n.t('page.settings.actions.newUser'),
            onClick: () => navigate(settingsRoutes.userManagementAddUserV2),
            'data-testid': testIds.settings.userManagement('newUserButton'),
          }),
      }}
      data-testid={testIds.settings.userManagement('page')}
    >
      <DmsDataGrid
        gridCode="user"
        actionCallback={actionCallback}
        data-testid={testIds.settings.userManagement('usersDG')}
      />
    </SettingsTemplate>
  );
}
